/* Publish by EComposer at 2025-08-08 09:24:38*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-9riqvl7rwzv"]=  window.__ectimmers["ecom-9riqvl7rwzv"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-9riqvl7rwzv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9riqvl7rwzv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-85541ph2smw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-85541ph2smw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o2p6cn132ff').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o2p6cn132ff', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vlriz3s8xj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vlriz3s8xj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d40ll9tbwiq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d40ll9tbwiq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wjfk5h81a59').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wjfk5h81a59', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kytvbn649x9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kytvbn649x9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zllhefwfxo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zllhefwfxo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vall3f1a4di').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vall3f1a4di', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vgfqhymd2ii').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vgfqhymd2ii', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rh70wi08thg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rh70wi08thg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ufkmiym7lqn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ufkmiym7lqn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a6plbbfp99k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a6plbbfp99k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ir95f27ua').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ir95f27ua', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wrmg4m3dp1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wrmg4m3dp1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sffph7gpye8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sffph7gpye8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-50bwhado5dq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-50bwhado5dq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0oinujx03q6q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0oinujx03q6q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-71bxz865hcv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-71bxz865hcv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yywp4gd6x2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yywp4gd6x2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6lrrzas6kbw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6lrrzas6kbw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zimgb4c3e1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zimgb4c3e1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o9rs84gnj4b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o9rs84gnj4b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hohc7stnqh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hohc7stnqh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5682udp9ira').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5682udp9ira', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wyavnhjwre').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wyavnhjwre', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q0j3dlhhpf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q0j3dlhhpf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t88bbn8xcfq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t88bbn8xcfq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gpu6qa24iyf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gpu6qa24iyf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wtp8ralv1q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wtp8ralv1q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hgechdgrlui').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hgechdgrlui', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f34oe0405ue').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f34oe0405ue', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dq02weinwsu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dq02weinwsu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fcylmvmvyri').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fcylmvmvyri', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-20j8wd8334rj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-20j8wd8334rj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oe02g5vrja7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oe02g5vrja7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uzov9sumstb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uzov9sumstb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fwi1hjlu1gm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fwi1hjlu1gm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hrshyuotp28').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hrshyuotp28', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tgyrllqjomn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tgyrllqjomn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uckr97yoq9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uckr97yoq9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fmpvpt6xk4e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fmpvpt6xk4e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nkbrenngwa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nkbrenngwa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kmqp03cfuom').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kmqp03cfuom', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yyttlaiyog').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yyttlaiyog', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tiuc9bczj3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tiuc9bczj3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-895e3d5xq7u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-895e3d5xq7u', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bdad6k7hnga').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bdad6k7hnga', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bu817mzda1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bu817mzda1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rzedyhdnsb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rzedyhdnsb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f0wrk40kpib').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f0wrk40kpib', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mbkashey16o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mbkashey16o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7ebcjz72tj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7ebcjz72tj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r4mx3y4wgc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r4mx3y4wgc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d4m91mkfyis').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d4m91mkfyis', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dar5couxwgf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dar5couxwgf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ywzqmej9p5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ywzqmej9p5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ti5fe8f45k9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ti5fe8f45k9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t8olykwzmen').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t8olykwzmen', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ud59kod70pl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ud59kod70pl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t1wks79h7k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t1wks79h7k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wmj39vawaym').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wmj39vawaym', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-djst234nxd7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-djst234nxd7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yquz6d8bo8n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yquz6d8bo8n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pk9ibh8ahu9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pk9ibh8ahu9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cp1pmu1ai5r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cp1pmu1ai5r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sgfcwvwfxf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sgfcwvwfxf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u9slvk1r51r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u9slvk1r51r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qp0kfrpu9aq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qp0kfrpu9aq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8l5sk3rcl4q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8l5sk3rcl4q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hse80cs5n1r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hse80cs5n1r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7qrj5yoxywo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7qrj5yoxywo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dsu4y3hat9c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dsu4y3hat9c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uejzp7o2tsj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uejzp7o2tsj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xjgxvljud8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xjgxvljud8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s0ropsfog5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s0ropsfog5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uml6spprzar').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uml6spprzar', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2zdtoqm0rct').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2zdtoqm0rct', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jndbl1y8d29').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jndbl1y8d29', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9nck0osl81').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9nck0osl81', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4sgfjnfksgv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4sgfjnfksgv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y3fnnje4cj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y3fnnje4cj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0vayzlr0aate').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0vayzlr0aate', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nbj7xerwidp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nbj7xerwidp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2eobndo6yxb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2eobndo6yxb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f0bod558rg4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f0bod558rg4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t2ptc7vessm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t2ptc7vessm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dw4icuxxhq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dw4icuxxhq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8zo0z717914').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8zo0z717914', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i2zy53ocafs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i2zy53ocafs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ik18w7o1y').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ik18w7o1y', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qkj9nu7cleq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qkj9nu7cleq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ke2wga0hbhk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ke2wga0hbhk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6z952h8vqpu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6z952h8vqpu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ho82o8jpo7h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ho82o8jpo7h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7sunkyca38c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7sunkyca38c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-szod5qwhjxm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-szod5qwhjxm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-irh5ln6fhf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-irh5ln6fhf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b94p1xp01yl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b94p1xp01yl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a9vwiros7v6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a9vwiros7v6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rawso9qbeyg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rawso9qbeyg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6zwq3xm1fh6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6zwq3xm1fh6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sulh7gv9a7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sulh7gv9a7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1mjy53tt0dbi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1mjy53tt0dbi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xa3l1dp5yqe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xa3l1dp5yqe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-myre64y59p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-myre64y59p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zov1imqsm47').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zov1imqsm47', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nrus5r17ym').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nrus5r17ym', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-27h6srw9kp2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-27h6srw9kp2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tgdnma729d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tgdnma729d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wnwofoltgi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wnwofoltgi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-toxgmwnbaj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-toxgmwnbaj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t2t1wkvy94a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t2t1wkvy94a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pk2evfn9m6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pk2evfn9m6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tg9m82pr7vl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tg9m82pr7vl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7wtpikhvtdp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7wtpikhvtdp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g531eivyj4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g531eivyj4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-69ygff7sm2r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-69ygff7sm2r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wi3wjb9lzo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wi3wjb9lzo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g9ghhsxb4h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g9ghhsxb4h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vydj45941b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vydj45941b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w5wbnl6e5d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w5wbnl6e5d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f8yazrsq16n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f8yazrsq16n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6lw1hq6xu1g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6lw1hq6xu1g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m89bm8xdexj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m89bm8xdexj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cte3mkpbu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cte3mkpbu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7o7e95b9fm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7o7e95b9fm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8krqin1wmfy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8krqin1wmfy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xi4rs5h2u7k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xi4rs5h2u7k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ld7g77owy2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ld7g77owy2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oouzevhmuln').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oouzevhmuln', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n9s3dmljoul').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n9s3dmljoul', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-71qjob6a0s7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-71qjob6a0s7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fznsiwq0wlw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fznsiwq0wlw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4pa3fzmn3we').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4pa3fzmn3we', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m4kmutubyo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m4kmutubyo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lttvs8ioaue').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lttvs8ioaue', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pcdh2n5tghg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pcdh2n5tghg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xa92yec296e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xa92yec296e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xx0cm84bhz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xx0cm84bhz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p8fiuzu00ai').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p8fiuzu00ai', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5nm121u86aq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5nm121u86aq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g6861cih6ni').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g6861cih6ni', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-98lrhrpmpxa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-98lrhrpmpxa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bq1rbabp3l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bq1rbabp3l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r6ylextvoxa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r6ylextvoxa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i4ywav2qfj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i4ywav2qfj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ysjyffu02a8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ysjyffu02a8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tntrvaaouj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tntrvaaouj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k6avxq23j5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k6avxq23j5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sc8jsn33kzc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sc8jsn33kzc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-14it4bmuu25').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-14it4bmuu25', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2eh52ez7a9i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2eh52ez7a9i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gxm69i70vs9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gxm69i70vs9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7nzov9gi1a3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7nzov9gi1a3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ma0eip8xmz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ma0eip8xmz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-orjl4mcoqyk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-orjl4mcoqyk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o67m84zlmze').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o67m84zlmze', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6silea6o0wf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6silea6o0wf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c7uu4xosvqm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c7uu4xosvqm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8tllc7v5rl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8tllc7v5rl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tsz3oy3wuqf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tsz3oy3wuqf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1vzj09lvws9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1vzj09lvws9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p498umjrn4e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p498umjrn4e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xq8y2nf3zte').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xq8y2nf3zte', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3l4jni59r9o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3l4jni59r9o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b5awllitwbe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b5awllitwbe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-07462faws4f7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-07462faws4f7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3qcjn8pywie').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3qcjn8pywie', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8i73uhf4q8l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8i73uhf4q8l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x4km0egig0n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x4km0egig0n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dlg9zuxjgq9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dlg9zuxjgq9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-he1pdvhhow').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-he1pdvhhow', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q0q66cavup').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q0q66cavup', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5a6360z1gv4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5a6360z1gv4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3c1bk6oxpfj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3c1bk6oxpfj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vggl8nsjv5s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vggl8nsjv5s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kykcefikit').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kykcefikit', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7gifdl0p78f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7gifdl0p78f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-umizse8pszs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-umizse8pszs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t5698hx916c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t5698hx916c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lbcvi11jbyj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lbcvi11jbyj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x7wzzy6wl6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x7wzzy6wl6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a3av6sc2a46').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a3av6sc2a46', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6089ukyv9be').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6089ukyv9be', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-adbrprw7o5e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-adbrprw7o5e', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-f65kzjnpetu"]=  window.__ectimmers["ecom-f65kzjnpetu"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-f65kzjnpetu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f65kzjnpetu', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7rel3sjqalp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7rel3sjqalp', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wlojmdvydlj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wlojmdvydlj', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v5cnd0r8ka').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v5cnd0r8ka', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vombaydipuk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vombaydipuk', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fuexb39gdzb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fuexb39gdzb', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qnjalobit0d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qnjalobit0d', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pkkbmtqdhc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pkkbmtqdhc', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e4q3skw6t3t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e4q3skw6t3t', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-99tjna93fb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-99tjna93fb', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rs0hoe8xvfb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rs0hoe8xvfb', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hgsu3sqqn0k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hgsu3sqqn0k', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-np8x3exdch').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-np8x3exdch', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cyzl0jgn71h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cyzl0jgn71h', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ef1l5sf8ohv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ef1l5sf8ohv', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b45wn9pu1v4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b45wn9pu1v4', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e4p76cctr4n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e4p76cctr4n', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qzcdcuw2j8b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qzcdcuw2j8b', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9qln7rh4xlc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9qln7rh4xlc', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dvqn7ewy0mb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dvqn7ewy0mb', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dyzjxw7w5wk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dyzjxw7w5wk', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l2ysp5swoxa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l2ysp5swoxa', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ojh9nz1k9ke').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ojh9nz1k9ke', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ihbscdsckvp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ihbscdsckvp', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tvhnvbhisjs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tvhnvbhisjs', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hubpz1dqaie').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hubpz1dqaie', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ra5ls68ndv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ra5ls68ndv', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i0s3le5lva').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i0s3le5lva', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-huecctskb3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-huecctskb3', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-83rh14w0r55').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-83rh14w0r55', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dspd8my6kun').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dspd8my6kun', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yzohprwo4p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yzohprwo4p', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hw2jca9lksu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hw2jca9lksu', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gziudms1sek').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gziudms1sek', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v2vwlwi3elf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v2vwlwi3elf', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tdfz2632kkh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tdfz2632kkh', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-95dxq9vyquu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-95dxq9vyquu', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mdacymsxpm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mdacymsxpm', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5h97125uap6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5h97125uap6', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ramv51ehvje').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ramv51ehvje', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m1zy9ieomxo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m1zy9ieomxo', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6wuzmdzzsqr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6wuzmdzzsqr', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-alseheda4v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-alseheda4v', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6tfwoj4hm7j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6tfwoj4hm7j', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zenpv5do1wc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zenpv5do1wc', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a4g2mk7pi8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a4g2mk7pi8', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c7qw37lubjq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c7qw37lubjq', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nluayrfj9qq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nluayrfj9qq', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9fjn8fyz2lh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9fjn8fyz2lh', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zqvglerq7dl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zqvglerq7dl', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-brd2s5kibt8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-brd2s5kibt8', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-08wqo5bc43h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-08wqo5bc43h', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2e5brij1wqh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2e5brij1wqh', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qkitemukmp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qkitemukmp', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-410nxjpskoj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-410nxjpskoj', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w81umr7rylq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w81umr7rylq', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9cak6j7lzzt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9cak6j7lzzt', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v5e01cs6kre').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v5e01cs6kre', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e48kiyxyrxa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e48kiyxyrxa', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nat6f60f57').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nat6f60f57', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hwz2nlx242o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hwz2nlx242o', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3xq6jvbdetf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3xq6jvbdetf', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eb7531tm97').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eb7531tm97', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k99gq9h35q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k99gq9h35q', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rtgtf7pqrmr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rtgtf7pqrmr', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z6bp1igkxn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z6bp1igkxn', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2trfcnri7qn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2trfcnri7qn', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1rhakpz6c45').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1rhakpz6c45', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-raqydwnmwk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-raqydwnmwk', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t0zdt97eg2e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t0zdt97eg2e', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9uhpylvbja').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9uhpylvbja', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cwzif3fe5o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cwzif3fe5o', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a5uye8gqms8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a5uye8gqms8', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-brr2o8iks2n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-brr2o8iks2n', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xjzdfqjvy6p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xjzdfqjvy6p', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4wapn2veu98').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4wapn2veu98', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jyrtkuioe8l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jyrtkuioe8l', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}